import { CurrencySetting, Point } from "../../type";

export type AnimationPoint = {
  x: number;
  y: number;
  isIceBreak: boolean;
  isDropdownPoint: boolean;
  groupId: number;
  endId: number;
  win: number;
  beforeWin?: number;
};

export type SymbolPayout = {
  x: number;
  y: number;
  value: number;
};

export type PiratesTreasureGameData = {
  category: number;
  animationPoints?: AnimationPoint[];
  totalMultiplier: number;
  preMultiplier: number;
  triggeredFeaturePoint?: Point;
  symbolPayouts: SymbolPayout[];
};

export enum Symbols {
  Spades = 201,
  Hearts = 202,
  Clubs = 203,
  Diamonds = 204,
  Ace = 101,
  King = 102,
  Queen = 103,
  Jack = 104,

  Multiplier = 300,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number };
  buyFreeSpinRate: number;
};
